import { render } from "./ResourceDetail.vue?vue&type=template&id=66514986&scoped=true&ts=true"
import script from "./ResourceDetail.vue?vue&type=script&lang=ts"
export * from "./ResourceDetail.vue?vue&type=script&lang=ts"

import "./ResourceDetail.vue?vue&type=style&index=0&id=66514986&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66514986"]])

export default __exports__